"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.asFullConfigOverrides = exports.asConfigOverrides = exports.asEndpointConfigOverrides = exports.applyFullConfigOverrides = exports.applyConfigOverrides = exports.applyEndpointConfigOverrides = void 0;
var invariant_1 = __importDefault(require("invariant"));
var user_1 = require("../../user");
function applyEndpointConfigOverrides(config, overrides) {
    var version = overrides.version;
    var overrides_X_out_of_100 = overrides.overrides_X_out_of_100;
    if (!version)
        return config;
    if (typeof overrides_X_out_of_100 === "number") {
        var endpointOverrides100 = (0, user_1.getUserHashes)().endpointOverrides100;
        if (endpointOverrides100 < overrides_X_out_of_100) {
            //^ in this case, we will "overrides" the config. it's ON.
        }
        else {
            version = config.version; // otherwise we don't override
        }
    }
    if (!version || config.version === version)
        return config; // nothing to change
    return __assign(__assign({}, config), { version: version });
}
exports.applyEndpointConfigOverrides = applyEndpointConfigOverrides;
function applyConfigOverrides(config, overrides) {
    var res = {
        id: config.id,
        stable: config.stable
    };
    if (config.experimental) {
        res.experimental = overrides.experimental
            ? applyEndpointConfigOverrides(config.experimental, overrides.experimental)
            : config.experimental;
    }
    if (config.stable) {
        res.stable = overrides.stable
            ? applyEndpointConfigOverrides(config.stable, overrides.stable)
            : config.stable;
    }
    if (config.experimental === res.experimental &&
        config.stable === res.stable) {
        return config; // nothing changed
    }
    return res;
}
exports.applyConfigOverrides = applyConfigOverrides;
function applyFullConfigOverrides(config, overrides) {
    var changed = false;
    var all = {};
    for (var k in config) {
        var c = config[k];
        var override = overrides[k];
        var o = override && c ? applyConfigOverrides(c, overrides[k]) : c;
        changed = changed || o !== c;
        all[k] = o;
    }
    return changed ? all : config;
}
exports.applyFullConfigOverrides = applyFullConfigOverrides;
function asEndpointConfigOverrides(o) {
    (0, invariant_1["default"])(o && typeof o === "object", "EndpointConfig: not an object");
    var copy = {};
    if (o && "version" in o) {
        (0, invariant_1["default"])(typeof o.version === "string", "endpointConfig.version should be string");
        copy.version = o.version;
    }
    if (o && "overrides_X_out_of_100" in o) {
        (0, invariant_1["default"])(typeof o.overrides_X_out_of_100 === "number", "endpointConfig.overrides_X_out_of_100 should a number");
        copy.overrides_X_out_of_100 = o.overrides_X_out_of_100;
    }
    return copy;
}
exports.asEndpointConfigOverrides = asEndpointConfigOverrides;
function asConfigOverrides(o) {
    (0, invariant_1["default"])(o && typeof o === "object", "ConfigOverrides: not an object");
    var copy = {};
    if ("stable" in o) {
        copy.stable = asEndpointConfigOverrides(o.stable);
    }
    if ("experimental" in o) {
        copy.experimental = asEndpointConfigOverrides(o.experimental);
    }
    return copy;
}
exports.asConfigOverrides = asConfigOverrides;
function asFullConfigOverrides(o) {
    (0, invariant_1["default"])(o && typeof o === "object", "FullConfigOverrides: not an object");
    var copy = {};
    for (var k in o) {
        copy[k] = asConfigOverrides(o[k]);
    }
    return copy;
}
exports.asFullConfigOverrides = asFullConfigOverrides;
//# sourceMappingURL=overrides.js.map